import { pipe } from 'fp-ts/lib/function';

// API_URL is processed during the frontend build
declare const API_URL: string;

/**
 * Get api endpoint full URL with origin and version
 */
export const apiEndpointToFullUrl = (pathname: string): string => {
  const baseUrl = pipe(new URL(API_URL, window.document.baseURI), ({ href }) =>
    href.endsWith('/') ? href.slice(0, -1) : href,
  );
  return `${baseUrl}${pathname}`;
};

/**
 * Get api endpoint based wherever API_URL points to - relative base path or absolute base url
 */
export const apiEndpointToBaseUrl = (pathname: string): string =>
  `${API_URL}${pathname}`;
